import $ from 'jquery';
import Auth from 'app/scripts/db/auth.coffee';
import { logoDomain } from '@trello/config';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React from 'react';
import { Storage } from '@trello/storage';
import Util from 'app/scripts/lib/util/index.coffee';
import getExperiment from 'app/scripts/lib/experiments/simple-test.coffee';
import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('home');
import { trackUe } from '@trello/analytics';
import { Navigation } from './navigation';
import { HomeTestIds } from '@trello/webdriverio-tests';
import { Analytics } from '@trello/atlassian-analytics';
import _ from 'underscore';

import { featureFlagClient } from '@trello/feature-flag-client';

export class HomeLeftSidebarContainer extends React.Component {
  constructor(props) {
    super(props);
    this.onCreateTeamClick = this.onCreateTeamClick.bind(this);
    this.setLastTab = this.setLastTab.bind(this);
    this.onTemplatesTabClick = this.onTemplatesTabClick.bind(this);

    this.onTeamHighlightsClick = this.trackSubLinkClick.bind(
      this,
      'shows',
      'team feeds',
      'team highlights',
    );
    this.onTeamReportsClick = () => {};
    this.onViewBoardsClick = this.trackSubLinkClick.bind(
      this,
      'shows more',
      'boards',
      'all team boards',
    );
    this.onMembersClick = this.trackSubLinkClick.bind(
      this,
      'opens',
      'members',
      'members',
    );
    this.onSettingsClick = this.trackSubLinkClick.bind(
      this,
      'opens',
      'settings',
      'settings',
    );
  }

  trackSubLinkClick(verb, directObj, buttonName) {
    const { modelCache, orgname } = this.props;
    const orgId = modelCache.findOne('Organization', 'name', orgname).id;
    const method = `by clicking ${buttonName} in left sidebar when filtered by team`;
    const context = { teamId: orgId };
    trackUe('home', verb, directObj, '', '', method, context);
  }

  onCreateTeamClick(e) {
    const CreateOrgView = require('app/scripts/views/organization/create-org-view.coffee');
    Util.preventDefault(e);

    const { orgname, model, modelCache } = this.props;

    const org = modelCache.findOne('Organization', 'name', orgname);
    const orgId = org ? org.id : undefined;
    const method = orgId
      ? 'by clicking create team in left sidebar when filtered by team'
      : 'by clicking create team in left sidebar';
    const context = orgId ? { teamId: orgId } : {};
    const member = modelCache.get('Member', Auth.myId());
    const createOpts = {};

    trackUe('home', 'opens', 'create team menu', '', '', method, context);

    if (member.isPaidManagedEntMember()) {
      createOpts.isEnterprise = true;
    }

    PopOver.toggle({
      elem: $(e.currentTarget),
      view: CreateOrgView,
      options: {
        model: model,
        modelCache: modelCache,
        createOpts,
        trackingOpts: {
          category: 'home',
        },
        method: 'by clicking create team in left sidebar',
      },
    });
  }

  setLastTab(url) {
    const Controller = require('app/scripts/controller/index.coffee');
    Storage.set(Controller.getHomeLastTabStorageKey(), url);
  }

  onTemplatesTabClick(templates, templateCategory) {
    const { allBoards } = this.props;
    trackUe(
      'home',
      'shows',
      'templates',
      '',
      '',
      'by clicking templates in left sidebar',
    );

    let sourceTab = 'homeScreen';
    if (templates && !templateCategory) {
      sourceTab = 'templateGalleryScreen';
    } else if (allBoards) {
      sourceTab = 'boardsScreen';
    }

    let actionSubjectIdTab = 'homeTab';
    if (templates && !templateCategory) {
      actionSubjectIdTab = 'templateGalleryTab';
    } else if (allBoards) {
      actionSubjectIdTab = 'boardsTab';
    }

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'tab',
      actionSubjectId: actionSubjectIdTab,
      source: sourceTab,
    });
  }

  render() {
    const {
      orgname,
      allBoards,
      orgBoards,
      modelCache,
      templateCategory,
      templates,
    } = this.props;

    const member = modelCache.get('Member', Auth.myId());
    const username = member.get('username');
    const orgs = member.getSortedOrgs();
    const enterprises = _.clone(member.enterpriseList.models)
      .filter((e) => e.id)
      .map((ent) => ({
        id: ent.get('id'),
        displayName: ent.get('displayName'),
        name: ent.get('name'),
        logoHash: ent.get('logoHash'),
      }))
      .sort((a, b) => (a.displayName || '').localeCompare(b.displayName || ''));
    const urlHome = '/';
    const urlBoards = `/${username}/boards`;
    const hasEnterpriseReports = featureFlagClient.get(
      'enterprise.reports',
      false,
    );

    return (
      <Navigation
        className="home-left-sidebar-container"
        homeTab={{
          href: urlHome,
          selected: !orgname && !allBoards && !templates,
          onClick: () => {
            this.setLastTab(urlHome);
            trackUe(
              'home',
              'shows',
              'home feeds',
              '',
              '',
              'by clicking home in left sidebar',
            );
          },
        }}
        boardsTab={{
          href: urlBoards,
          selected: Boolean(allBoards),
          onClick: () => {
            this.setLastTab(urlBoards);
            trackUe(
              'home',
              'shows',
              'boards',
              '',
              '',
              'by clicking boards in left sidebar',
            );
          },
        }}
        teamTabs={orgs.map((org) => {
          const Controller = require('app/scripts/controller/index.coffee');
          const name = org.get('name');
          const displayName = org.get('displayName');
          const logoHash = org.get('logoHash');
          const homeUrl = `/${name}/home`;
          const idEnterprise = org.get('idEnterprise');
          let linkTabs = [];
          const orgReportsUrl = Controller.getOrganizationReportsUrl(name);

          if (orgname) {
            const orgHighlightsUrl = `/${name}/highlights`;
            const orgBoardsUrl = Controller.getOrganizationUrl(name);
            const orgMembersUrl = Controller.getOrganizationMembersUrl(name);
            const orgAccountUrl = Controller.getOrganizationAccountUrl(name);
            linkTabs = [
              {
                displayName: format('highlights'),
                iconName: 'heart',
                href: orgHighlightsUrl,
                onClick: this.onTeamHighlightsClick,
                selected: !orgBoards,
              },
              {
                displayName: format('home-all-team-boards'),
                iconName: 'board',
                href: orgBoardsUrl,
                onClick: this.onViewBoardsClick,
                external: true,
              },
              {
                displayName: format('home-view-members'),
                iconName: 'organization',
                href: orgMembersUrl,
                onClick: this.onMembersClick,
                external: true,
              },
              {
                displayName: format('home-view-settings'),
                iconName: 'gear',
                href: orgAccountUrl,
                onClick: this.onSettingsClick,
                external: true,
              },
            ];

            if (hasEnterpriseReports && org.belongsToRealEnterprise()) {
              linkTabs.splice(1, 0, {
                displayName: format('home-view-team-report'),
                // TODO: When we've added the proper icon use it here
                iconName: 'collection',
                href: orgReportsUrl,
                onClick: this.onTeamReportsClick,
                selected: window.location.pathname.indexOf(orgReportsUrl) === 0,
              });
            }

            // Since we manually mutate the linkTabs list to add items conditionally,
            // map over them to add the index as a key on each item
            linkTabs = linkTabs.map((linkTab, idx) => ({
              ...linkTab,
              key: idx,
            }));
          }

          return {
            key: org.id,
            href: homeUrl,
            selected:
              name === orgname &&
              Boolean(orgBoards) &&
              window.location.pathname.indexOf(orgReportsUrl) !== 0,
            expanded: name === orgname,
            displayName,
            orgId: org.id,
            billingUrl: Controller.getOrganizationBillingUrl(org.get('name')),
            logoUrl1x: logoHash && `${logoDomain}/${logoHash}/30.png`,
            logoUrl2x: logoHash && `${logoDomain}/${logoHash}/170.png`,
            linkTabs,
            idEnterprise,
            onClick: () => {
              this.setLastTab(homeUrl);
              return trackUe(
                'home',
                'shows',
                'team feeds',
                '',
                '',
                'by clicking team name in left sidebar',
                { teamId: org.id },
              );
            },
          };
        })}
        templatesTab={{
          href: '/templates',
          onClick: () => {
            this.onTemplatesTabClick(templates, templateCategory);
          },
          templateCategory,
          expanded: templates,
          selected: templates && !templateCategory,
          shouldShowNewLozenge: !Auth.me().isDismissed(
            'templates-in-app-gallery',
          ),
        }}
        enterprises={enterprises}
        createTeamButton={{
          onClick: this.onCreateTeamClick,
        }}
      />
    );
  }
}
